import React from "react";
import { ICouncilMemberData } from "../exports/interfaces";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import useMobile from "../hooks/useMobile";

interface CouncilMemberDialogProps {
  open: boolean;
  onClose: () => void;
  member: ICouncilMemberData | null;
}

const PopUpDialog: React.FC<CouncilMemberDialogProps> = ({
  open,
  onClose,
  member,
}) => {
  const mobile = useMobile();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <h2 className="section-title__title">{member?.name}</h2>
        {member?.category
          .toLowerCase()
          .replace(/\b\w/g, (char) => char.toUpperCase())}
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
          }}
        >
          <i className="icon-cross" style={{ fontSize: "16px" }}></i>
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="detailsPopup"
        sx={{ padding: "24px", marginTop: "15px" }}
      >
        <div
          style={{
            display: "flex",
            gap: "24px",
            flexDirection: mobile ? "column" : "row",
          }}
        >
          {/* Image Section */}
          <div
            style={{
              flex: "0 0 35%",
            }}
          >
            <img
              src={
                member?.image[0]?.media?.url
                  ? `${process.env.REACT_APP_cmsUrl}${member?.image[0].media.url}`
                  : undefined
              }
              alt={member?.name}
              style={{
                width: "100%",
                height: "320px",
                borderRadius: "8px",
                objectFit: member?.name.toUpperCase().includes("JERIN")
                  ? "inherit"
                  : "cover",
                filter: "brightness(0.9)",
                objectPosition: "top",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              }}
            />
          </div>

          {/* Content Section */}
          <div
            className="detailsPopup"
            style={{ flex: "1", overflowY: "auto", height: "320px" }}
          >
            <p
              style={{
                color: "#727272",
                textAlign: "justify",
                padding: "0px 12px",
                marginBottom: "0px",
              }}
            >
              {member?.description}
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PopUpDialog;
